import Input from 'components/Input';
import { useTranslate } from 'hooks/translation-hooks';

const Address = ({ register, errors }) => {
  const t = useTranslate('caseOpening');
  return (
    <Input
      {...register('additionalAddress', {
        required: false,
      })}
      error={
        errors.additionalAddress &&
        'incident_location-address_line2_error_format'
      }
      label={t('incident_location-address_line2')}
      placeholder={t('incident_location-address_line2_placeholder')}
      testId="additionalAddress"
      maxLength={255}
    />
  );
};

export default Address;
